export const ANSWER_QUESTION = 'QUIZZES_ANSWER_QUESTION'
export const BUY_WILDCARD = 'QUIZZES_BUY_WILDCARD'
export const CLEAR_RESPONSES = 'QUIZZES_CLEAR_RESPONSES'
export const CREATE_QUESTION = 'QUIZZES_CREATE_QUESTION'
export const END_FLOW = 'QUIZZES_END_FLOW'
export const GET_DISPUTE_QUESTION = 'QUIZZES_GET_DISPUTE_QUESTION'
export const GET_QUESTION = 'QUIZZES_GET_QUESTION'
export const GET_QUESTIONS_LIST = 'QUIZZES_GET_QUESTIONS_LIST'
export const LIKE_QUESTION = 'QUIZZES_LIKE_QUESTION'
export const REFUSE_QUESTION = 'QUIZZES_REFUSE_QUESTION'
export const SAVE_QUESTION_OK = 'QUIZZES_SAVE_QUESTION_OK'
export const SAVE_QUESTION_ERROR = 'QUIZZES_SAVE_QUESTION_ERROR'
export const SET_QUESTION = 'QUIZZES_SET_QUESTION'
export const SET_QUESTIONS_LIST = 'QUIZZES_SET_QUESTIONS_LIST'
export const SET_DISPUTE_LIST = 'QUIZZES_SET_DISPUTE_LIST'
export const SET_VOTE_QUESTION = 'QUIZZES_SET_VOTE_QUESTION'
export const VOTE_QUESTION = 'QUIZZES_VOTE_QUESTION'
export const USE_WILDCARD = 'QUIZZES_USE_WILDCARD'
export const SET_FEEDBACK = 'QUIZZES_SET_FEEDBACK'
export const CLEAR_FEEDBACK = 'QUIZZES_CLEAR_FEEDBACK'
export const PASS_AND_UPDATE_COUNTER = 'QUIZZES_PASS_AND_UPDATE_COUNTER'
export const CHANGE_FILTER = 'QUIZZES_CHANGE_FILTER'
export const SEARCH_QUESTION = 'QUIZZES_SEARCH_QUESTION'

export const GET_DISPUTES_LIST = 'MINING_GET_DISPUTES_LIST'
export const GET_ALL_DISPUTES_LIST = 'MINING_GET_ALL_DISPUTES_LIST'
export const GET_DISPUTES_SUCCESS = 'MINING_GET_DISPUTES_SUCCESS'
export const GET_DISPUTES_ERROR = 'MINING_GET_DISPUTES_ERROR'

export const answerQuestion = (question) => {
  return { type: ANSWER_QUESTION, data: question }
}
export const buyWildcard = () => {
  return { type: BUY_WILDCARD }
}
export const createQuestion = (question) => {
  return { type: CREATE_QUESTION, data: question }
}
export const clearResponses = () => {
  return { type: CLEAR_RESPONSES }
}
export const endFlow = () => {
  return { type: END_FLOW }
}
export const getDisputeQuestion = () => {
  return { type: GET_DISPUTE_QUESTION }
}
export const getQuestion = () => {
  return { type: GET_QUESTION }
}
export const getQuestionsList = () => {
  return { type: GET_QUESTIONS_LIST }
}
export const getAllDisputes = () => {
  return { type: GET_ALL_DISPUTES_LIST }
}
export const likeQuestion = (question) => {
  return { type: LIKE_QUESTION, data: question }
}
export const refuseQuestion = (question) => {
  return { type: REFUSE_QUESTION, data: question }
}
export const saveQuestionOk = () => {
  return { type: SAVE_QUESTION_OK }
}
export const saveQuestionError = (error) => {
  return { type: SAVE_QUESTION_ERROR, data: error }
}
export const setQuestion = (question) => {
  return { type: SET_QUESTION, data: question }
}
export const setQuestionsList = (questionList) => {
  return { type: SET_QUESTIONS_LIST, data: questionList }
}
export const setDisputesList = (disputesList) => {
  return { type: SET_DISPUTE_LIST, data: disputesList }
}
export const setVoteQuestion = (question) => {
  return { type: SET_VOTE_QUESTION, data: question }
}
export const useWildcard = (question) => {
  return { type: USE_WILDCARD, data: question }
}
export const voteQuestion = (question) => {
  return { type: VOTE_QUESTION, data: question }
}
export const setFeedBack = (data) => ({
  type: SET_FEEDBACK,
  data,
})
export const changeFilter = (filter) => ({
  type: CHANGE_FILTER,
  data: filter,
})
export const searchQuestion = (search) => ({
  type: SEARCH_QUESTION,
  data: search,
})
export const clearFeedBack = () => ({
  type: CLEAR_FEEDBACK,
})

export const passAndUpdateCounter = (type) => {
  return { type: PASS_AND_UPDATE_COUNTER, data: type }
}
export const getDisputesList = () => ({
  type: GET_DISPUTES_LIST,
})

export const getDisputesSuccess = (data) => ({
  type: GET_DISPUTES_SUCCESS,
  data,
})

export const getDisputesError = (error) => ({
  type: GET_DISPUTES_ERROR,
  error,
})
